// to set the api route for backend
// in my instanes in AWS 'http://34.222.23.20:5000'
// export const route='http://34.222.23.20:5000'

export const route = 'https://evenosmall.com'
// export const route = 'https://render-evenostesting2.onrender.com'
// export const route = "";
